export const getApiHost = (): string | undefined => {
  return process.env.REACT_APP_API_HOST;
};
